import {CONTAINER_LAYOUT_TYPES, ITEM_LAYOUT_TYPES, COMPONENT_LAYOUT_TYPES} from '../defaultResponsiveLayoutDefinitions'

export const responsiveSectionDefaultResponsiveLayout = {
    getLayout: () => ({
        COMPONENT_LAYOUT_TYPES: COMPONENT_LAYOUT_TYPES.MIN_HEIGHT,
        CONTAINER_LAYOUT_TYPES: CONTAINER_LAYOUT_TYPES.FRACTION,
        ITEM_LAYOUT_TYPES: ITEM_LAYOUT_TYPES.STRETCH_ITEM_LAYOUT
    })
}
